import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";
import Noise from "../Voices/Noise"; // SAFARI Fix

var OfflineAudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;

var Reverb =
/*#__PURE__*/
function (_Effect) {
  _inherits(Reverb, _Effect);

  function Reverb(context) {
    var _this;

    _classCallCheck(this, Reverb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Reverb).call(this, context));
    _this.name = "reverb";
    _this.attack = 0;
    _this.decay = 0.2;
    _this.release = 0.8;
    return _this;
  }

  _createClass(Reverb, [{
    key: "setup",
    value: function setup() {
      this.effect = this.context.createConvolver();
      this.reverbTime = 2;
      this.attack = 0.001;
      this.decay = 0.2;
      this.release = 0.8;
      this.wet = this.context.createGain();
      this.wet.gain.value = 1;
      this.dry = this.context.createGain();
      this.dry.gain.value = 1;
      this.renderTail();
      this.wireUp();
    }
  }, {
    key: "wireUp",
    value: function wireUp() {
      this.input.connect(this.dry);
      this.input.connect(this.effect);
      this.dry.connect(this.output);
      this.effect.connect(this.wet);
      this.wet.connect(this.output);
    }
  }, {
    key: "renderTail",
    value: function renderTail() {
      var _this2 = this;

      var tailContext = new OfflineAudioContext(2, this.context.sampleRate * this.reverbTime, this.context.sampleRate);

      tailContext.oncomplete = function (buffer) {
        _this2.effect.buffer = buffer.renderedBuffer;
      };

      var tailOsc = new Noise(tailContext, 1);
      tailOsc.init();
      tailOsc.connect(tailContext.destination);
      tailOsc.attack = this.attack;
      tailOsc.decay = this.decay;
      tailOsc.release = this.release;
      tailOsc.on({
        frequency: 500,
        velocity: 1
      });
      tailContext.startRendering();
      setTimeout(function () {
        tailOsc.off();
      }, 1);
    }
  }, {
    key: "decayTime",
    set: function set(value) {
      var dc = value / 3;
      this.reverbTime = value;
      this.attack = 0;
      this.decay = dc;
      this.release = dc;
      this.renderTail();
    }
  }]);

  return Reverb;
}(Effect);

export { Reverb as default };